const BASE = 36;
const T_MIN = 1;
const T_MAX = 26;
const SKEW = 38;
const DAMP = 700;
const INITIAL_BIAS = 72;
const INITIAL_N = 128;
const DELIMITER = "-";

function basicToDigit(codePoint) {
  if (codePoint - 48 < 10) {
    return codePoint - 22;
  }
  if (codePoint - 65 < 26) {
    return codePoint - 65;
  }
  if (codePoint - 97 < 26) {
    return codePoint - 97;
  }
  return BASE;
}

function adapt(delta, numPoints, firstTime) {
  delta = firstTime ? Math.floor(delta / DAMP) : delta >> 1;
  delta += Math.floor(delta / numPoints);

  let k = 0;
  while (delta > (((BASE - T_MIN) * T_MAX) >> 1)) {
    delta = Math.floor(delta / (BASE - T_MIN));
    k += BASE;
  }

  return k + Math.floor(((BASE - T_MIN + 1) * delta) / (delta + SKEW));
}

export function decodePunycode(input) {
  if (!input) return "";

  let output = [];
  let n = INITIAL_N;
  let i = 0;
  let bias = INITIAL_BIAS;

  const lowerInput = input.toLowerCase();
  const basic = lowerInput.lastIndexOf(DELIMITER);

  let index = 0;
  if (basic >= 0) {
    for (; index < basic; index += 1) {
      output.push(lowerInput.charCodeAt(index));
    }
    index += 1;
  } else {
    index = 0;
  }

  while (index < lowerInput.length) {
    const oldI = i;
    let w = 1;

    for (let k = BASE; ; k += BASE) {
      if (index >= lowerInput.length) {
        return "";
      }

      const digit = basicToDigit(lowerInput.charCodeAt(index++));
      if (digit >= BASE) {
        return "";
      }

      i += digit * w;
      const t = k <= bias ? T_MIN : k >= bias + T_MAX ? T_MAX : k - bias;

      if (digit < t) {
        break;
      }

      w *= BASE - t;
    }

    const outLength = output.length + 1;
    bias = adapt(i - oldI, outLength, oldI === 0);
    n += Math.floor(i / outLength);
    i %= outLength;

    output.splice(i, 0, n);
    i += 1;
  }

  return String.fromCodePoint(...output);
}
